
import defaultWorkbook from './DefaultWorkbook.js';
import wp from '@/services/WordpressService.js';
import { EventBus } from './EventBus.js';

export default {

    /**
     * 
     * @param {Function} store.commit
     *
     * @param {String} data.post_title
     * @param {String} data.post_excerpt
     * @param {String} data.post_content
     *
     */
    async createWorkbook({ commit }, data) {
        console.log('>>> createWorkbook', data)

        commit('SET_LOADING_STATE', true);
        let workbook =  {...defaultWorkbook, ...data};
        let response = await wp.createWorkbook(workbook);
        commit('SET_LOADING_STATE', false);

        /**
         * TODO: for some reason this does not dispatch. Find out. In the meantime
         * the refresh action must be invoked from the creating script.
         */
        await this.dispatch('getWorkbooks');

        EventBus.trigger(EventBus.events.OPPORTUNITY_CREATED, [response]);

        return response;
    },



    /**
     * 
     * @param {Function} store.commit
     * @param {Object} store.state
     * 
     * @param {Boolean} forceRefresh 
     * 
     * @returns 
     */
    async getWorkbooks({ commit , state }, forceRefresh=false) {
        let collection;

        if(state.workbooks.length > 0 && forceRefresh === false) {
            collection = state.workbooks;
        } else {
            commit('SET_LOADING_STATE', true);
            collection = await wp.getWorkbooks(true); // pass true to include metadata
            commit('SET_LOADING_STATE', false);
        }

        commit('SET_WORKBOOKS', collection);

        return collection;
    },



    async getWorkbook({ commit , state }, name) {
        let workbook;

        if(typeof state.active.workbooks[name] != 'undefined') {
            workbook = state.active.workbooks[name];
        } else {
            commit('SET_LOADING_STATE', true);
            workbook = await wp.getWorkbook(name);
            commit('SET_LOADING_STATE', false);
        }

        commit('SET_WORKBOOK', {
            name: name, 
            data: workbook
        });

        commit('SET_CURRENT_WORKBOOK', workbook );

        return workbook;
    }, 




    /**
     * 
     * 
     * @param {Function} store.commit
     * @param {Object} store.state
     * 
     * @param {*} request.ID 
     * @param {*} request.title 
     * @param {*} request.name 
     * @param {*} request.content 
     * @param {*} request.excerpt 
     * @param {*} request.meta 
     * 
     * @returns 
     */
     async getWorkbooksByAppId({ commit , state }, request) {
        state

        commit('SET_LOADING_STATE', true);
        let collection = await wp.getWorkbooksByAppId(request.ID);
        commit('SET_LOADING_STATE', false);

        commit('SET_WORKBOOKS', collection);

        return collection;
    }, 




    /**
     * @param {Object} context
     * @param {Function} context.commit
     * @param {Object} context.state
     *
     * @param {Object} request
     * @param {Object} request.form Name of the form
     * @param {Object} request.field The field to be updated
     * @param {Object} request.value
     * @param {Object} request.opportunity_id
     *
     *
     */
    // async updateOpportunityFormField({ commit , state, getters }, request) {
    //     if(getters?.currentOpportunity?.content?.[request.form]?.fields) {
    //         state.current.opportunity.content[request.form].fields[request.field] = request.value;
    //     }

    //     commit('SET_LOADING_STATE', true);
    //     await wp.updateOpportunityFormField(request);
    //     commit('SET_LOADING_STATE', false);
    // }, 



    /**
     * @param {Object} context
     * @param {Function} context.commit
     * @param {Object} context.state
     * @param {Object} request
     * @param {Object} request.form Name of the form
     * @param {Object} request.value
     * @param {Object} request.opportunity_id
     *
     *
     */
    // async updateOpportunityForm({ commit , state }, request) {
    //     commit , state;
    //     commit('SET_LOADING_STATE', true);
    //     await wp.updateOpportunityForm(request);
    //     commit('SET_LOADING_STATE', false);
    // }, 




    /**
     * @param {Object} context
     * @param {Function} context.commit
     * @param {Object} context.state
     * @param {Object} request
     * @param {Object} request.ID Name of the form
     * @param {Object} request.post_title
     * @param {Object} request.post_content
     * @param {Object} request.post_excerpt
     *
     *
     */
    async updateWorkbook({ commit }, request) {
        commit('SET_LOADING_STATE', true);
        let response = await wp.updateWorkbook(request);
        commit('SET_LOADING_STATE', false);

        commit('SET_WORKBOOK', {
            name: response.name, 
            data: response
        });

        EventBus.trigger(EventBus.events.WORKBOOK_UPDATED, [response]);

        return response;
    }, 

    /**
     * 
     * @param {Object} context 
     * @param {Object} context.state 
     * @param {Function} context.commit
     * 
     * @param {Object} workbook 
     * @param {Number} workbook.ID
     * @param {String} workbook.name
     * @param {String} workbook.title
     */
    async deleteWorkbook({ state, commit }, workbook) {
        commit('SET_LOADING_STATE', true);
        let response = await wp.deleteWorkbook(workbook.ID, false /** forceDelete */);
        commit('SET_LOADING_STATE', false);

        /** remove if strategy is current */
        (state.current.workbook?.name == workbook.name) && (state.current.workbook = null);

        /** remove if strategy is in active list */
        (state.active.workbooks[workbook.name]) && delete(state.active.workbooks[workbook.name]);

        EventBus.trigger(EventBus.events.WORKBOOK_DELETED, [response]);
        return true;
    }, 







    /**
     * 
     * @param {*} context 
     * @param {*} context.state 
     * @param {*} context.commit
     * 
     * @param {*} request 
     * @param {*} request.ID
     * @param {*} request.name
     * @param {*} request.title
     */
    // async trashOpportunity({ state, commit }, request) {
    //     commit('SET_LOADING_STATE', true);
    //     let response = await wp.trashOpportunity(request.name);
    //     commit('SET_LOADING_STATE', false);

    //     /** remove if strategy is current */
    //     (state.current.opportunity.name == request.name) && (state.current.opportunity = null);

    //     /** remove if strategy is in active list */
    //     (state.active.opportunities[request.name]) && delete(state.active.opportunities[request.name]);

    //     EventBus.trigger(EventBus.events.OPPORTUNITY_TRASHED, [response]);
    //     return true;
    // }, 







    /**
     * @param {Function} commit
     * @param {Object} request
     * @param {Object} request.ID 
     * @param {Object} request.post_title
     *
     *
     */
    // async renameOpportunity({ commit }, request) {
    //     commit('SET_LOADING_STATE', true);
    //     let response = await wp.renameOpportunity(request);
    //     commit('SET_LOADING_STATE', false);

    //     EventBus.trigger(EventBus.events.OPPORTUNITY_RENAMED, [response]);
    // }, 





    // async duplicateWorkbook({ commit }, request) {
    //     commit('SET_LOADING_STATE', true);
    //     let response = await wp.duplicateWorkbook(request);
    //     commit('SET_LOADING_STATE', false);

    //     EventBus.trigger(EventBus.events.WORKBOOK_DUPLICATED, [response]);
    // }, 





    // async createOpportunityTemplate({ commit }, request) {
    //     commit('SET_LOADING_STATE', true);
    //     let response = await wp.createOpportunityTemplate(request);
    //     commit('SET_LOADING_STATE', false);

    //     EventBus.trigger(EventBus.events.OPPORTUNITY_TEMPLATE_CREATED, [response]);
    // }, 




    // async fetchOpportunityTemplates({ commit , state }) {
    //     let collection;

    //     if(state.opportunityTemplates.length > 0) {
    //         collection = state.opportunityTemplates;
    //     } else {
    //         commit('SET_LOADING_STATE', true);
    //         collection = await wp.getOpportunityTemplatesFromCache();
    //         commit('SET_LOADING_STATE', false);
    //     }

    //     commit('SET_OPPORTUNITY_TEMPLATES', collection);

    //     return state.opportunityTemplates;
    // },






}